import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import Typography from '@cdo/apps/componentLibrary/typography';
import { componentSizeToBodyTextSizeMap } from '@cdo/apps/componentLibrary/common/constants';
import moduleStyles from './checkbox.module.scss';
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/CheckboxTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Checkbox Component.
 * Can be used to render a checkbox or as a part of bigger/more complex components (e.g. Checkbox Dropdown).
 */
var Checkbox = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, name = _a.name, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.indeterminate, indeterminate = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'm' : _d;
    var checkboxRef = useRef(null);
    var bodyTextSize = componentSizeToBodyTextSizeMap[size];
    useEffect(function () {
        if (checkboxRef === null || checkboxRef === void 0 ? void 0 : checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [checkboxRef, indeterminate]);
    return (React.createElement("label", { className: classnames(moduleStyles.label, moduleStyles["label-".concat(size)]) },
        React.createElement("input", { type: "checkbox", ref: checkboxRef, name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }),
        React.createElement("i", { className: "fa-solid" }),
        label && (React.createElement(Typography, { semanticTag: "span", visualAppearance: bodyTextSize }, label))));
};
export default Checkbox;
